<template>
    <div class="row">
    <div class="col-sm-12">
      <div class="card">
        <div class="card-body">
          <h4 class="header-title mt-0 mb-1">{{$t('tag.form.information')}} </h4>
          <p class="sub-header"></p>

          <div class="row">

            <div class="col-12">
              <TextField 
                :placeholder="$t('tag.form.name.placeholder')"
                :label="$t('tag.form.name.label')"
                v-model="model.name"
              />
            </div>

          </div>
          
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import FormMixin from '@mixins/form'
import { required } from 'vuelidate/lib/validators'

export default {
  mixins: [ FormMixin ],
  components: {
    TextField: () => import('@components/form2/textfield')
  },
  data () {
    return {
      model:{
        name: '',
        remarks: '',
      },
    }
  },
  props: {
    parameters: {
      type: Object,
      default: () => {}
    }
  },
  validations: {
    model:{
      name: { required }
    }
  },
  computed: {
    tagID() {
      let parameters = this.parameters || {}
      return parameters.tagID
    },
    submitted() {
      let parameters = this.parameters || {}
      return parameters.submitted
    },
  },
  methods: {
    fetchData() {
      let param = {}
      param.id = this.tagID

      return this.$store.dispatch('tag/find', param)
      .then(res => {
        if (res && res.data) {
          this.model = res.data
        }
      })
    }
  },
  watch: {
    tagID: function () {
      this.fetchData()
    },
    submitted: function () {
      this.fetchData()
    }
  },
  mounted() {
    if (this.tagID) {
      this.fetchData()
    }
  }
}
</script>